import { api } from './api';

/** What a person edits on the investor screen; the rest of its row is not theirs to change. */
const COLUMNS = ['NAME', 'EMAIL', 'PHONE', 'CELL', 'ADDRESS', 'CITY', 'STATE', 'ZIP', 'FIRM_ID', 'DECEASED', 'SECOND_CONTACT_ID'];

/**
 * Save an edit from the investor screen. The server carries it on to the
 * investor's Kore lead, and refuses the save when Kore does not accept it.
 *
 * @param {string|number} id ARCIMEDES_ROW_ID
 * @param {Object} investor the row as the screen holds it
 * @returns {Promise<Object>} the saved investor
 */
export function updateInvestor(id, investor) {
    const body = {};

    COLUMNS.forEach((column) => {
        if (investor[column] !== undefined) body[column] = investor[column];
    });

    return api.patch(`/investors/${id}`, body).then((res) => res.data);
}
